<template>
  <PageLayout class="pets-page">
      <div class="pets-page__title-block">
        <div class="pets-page__title">
          <Breadcrumbs
            class="pets-page__breadcrumbs"
            :breadcrumbs="getBreadcrumbs"
          />
        </div>
        <WhiteButton
          size="medium"
          @click="goBack"
        >
          Назад до калькулятора
        </WhiteButton>
      </div>
    <PetsOffers :calculation-params="calculationParams" />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import { pages } from '@/entities/current-page';
import { PetsOffers } from '@/features/pets-offers';
import { Breadcrumbs } from '@/shared/ui/breadcrumbs';
import { WhiteButton } from '@/shared/ui/form';
import { PageLayout } from '@/shared/ui/layouts';

export default {
  created() {
    this.changeActivePage(pages.PRODUCTS_AND_PROPOSITIONS);
  },
  components: { Breadcrumbs, PageLayout, PetsOffers, WhiteButton },
  computed: {
    getBreadcrumbs() {
      return [
        {
          title: 'Панель управління',
          url: '#',
        },
        {
          title: 'Страхування тварин',
          url: '#',
        },
        {
          title: 'Пропозиції від СК',
          url: '#',
        },
      ];
    },
    calculationParams() {
      return this.decodeCalculationParams(this.$route.query);
    },
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
    goBack() {
      this.$router.push({ name: 'petsCalculator' });
    },
    decodeCalculationParams(params) {
      try {
        return {
          startFrom: params?.startFrom || null,
          insurancePeriod: params?.insurancePeriod || null,
          earnings: params?.earnings ? Number(params.earnings) : null,
        };
      } catch (_) {
        return {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pets-page {
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  color: #09090B;

  &__title-block {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    @media (min-width: 1201px) {
      margin-right: 16px;
    }
  }

  &__breadcrumbs {
    margin-bottom: 0;
  }
}

::v-deep .breadcrumbs {
  margin-bottom: 0 !important;
}
</style>
